// 菜单数据
export default [{
    path: '/index',
    name: 'Index',
    title: '首页',
    icon: 'el-icon-s-home',
  },
  {
    path: '/staff',
    name: 'Staff',
    title: '员工信息管理',
    icon: 'el-icon-user-solid',
  },
  {
    path: '/org',
    name: 'Org',
    title: '机构管理',
    icon: 'el-icon-office-building',
  },
  {
    path: '/examination-data',
    name: 'ExaminationData',
    title: '体检数据管理',
    icon: 'el-icon-s-data',
  },
  {
    path: '/medical-appointment',
    name: 'MedicalAppointment',
    title: '体检预约查询',
    icon: 'el-icon-search',
  },
  {
    path: '/medical-report',
    name: 'MedicalReport',
    title: '体检报告',
    icon: 'el-icon-document',
  },
  {
    path: '/subsidiary',
    name: 'Subsidiary',
    title: '子公司管理',
    icon: 'el-icon-menu',
  }
]